import { Assets } from "src/app/core/Dtos/assets-enum";

export class TraderInstructionArgs {
    public Asset: Assets;
    public InstructionId: number | string;
    public IsAdHoc: boolean;
    constructor(asset: Assets, instructionId: number | string, isAdHoc: boolean)
    {
        this.Asset = asset;
        this.InstructionId = instructionId;
        this.IsAdHoc = isAdHoc;
    }
  }